/* Theme B cart drawer · "Täydennä tilaus" one-tap add rows + in-drawer quick add.
   · rows: /recommendations/products.json?intent=complementary for the cart's products, minus what is already in the cart,
     available single-variant products only, max 2 (data-limit). Focused add-ons beat more products in published drawer
     tests and generic picks hurt conversion, so there is no related/bestseller filler: nothing relevant → no block.
     The cheapest candidate whose price
     closes the free-shipping gap is listed first and tagged "→ toimitus 0 €" (a fact, never a nudge we can't keep).
   · cart.js replaces the drawer body's innerHTML on every cart change, so rows are rebuilt from a per-product cache
     right after (cart:updated) and by a guarded MutationObserver for any path that skips that event.
   · add: POST cart/add.js, then the theme's own cart:refresh with open:true → the drawer stays open and re-renders.
   · product data only ever reaches the DOM through textContent / attributes (no innerHTML). */
(function () {
  'use strict';
  if (window.__tbbCart) return;
  window.__tbbCart = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FETCH_LIMIT = 8;
  var SAFETY_MS = 8000;
  var recs = {};      // productId -> { comp: [] }
  var inflight = {};  // productId -> Promise
  var lastAddedVariant = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function drawer() { return document.getElementById('CartDrawer'); }

  function money(cents) {
    try {
      if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      }
    } catch (e) { /* fall through to Intl */ }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return (cents / 100).toLocaleString('fi-FI', { style: 'currency', currency: cur });
  }

  function imgUrl(src, width) {
    if (!src) return '';
    try {
      var u = new URL(src.indexOf('//') === 0 ? 'https:' + src : src, location.href);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) { return src; }
  }

  function announce(msg) {
    var live = document.querySelector('[data-tbbc-live]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 50);
  }

  /* ---------- data ---------- */
  function fetchIntent(pid, intent) {
    var url = ROOT + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&intent=' + intent + '&limit=' + FETCH_LIMIT;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('recommendations ' + intent + ' ' + r.status); return r.json(); })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function (err) { console.warn('[tb-b-cart]', err.message); return []; });
  }

  function loadRecs(pid) {
    if (recs[pid]) return Promise.resolve(recs[pid]);
    if (inflight[pid]) return inflight[pid];
    inflight[pid] = fetchIntent(pid, 'complementary').then(function (comp) {
      recs[pid] = { comp: comp };
      delete inflight[pid];
      return recs[pid];
    });
    return inflight[pid];
  }

  function cartProductIds(root) {
    var ids = [];
    root.querySelectorAll('.cdr__item[data-product-id]').forEach(function (li) {
      var id = li.getAttribute('data-product-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function isOfferable(p, inCart) {
    if (!p || !p.available || inCart[String(p.id)]) return false;
    if (!p.variants || p.variants.length !== 1 || !p.variants[0].available) return false;
    return !/gift ?card|lahjakortti/i.test(p.product_type + ' ' + p.title);
  }

  /* take turns across the cart's products (newest first) so one line can't fill every row, deduped */
  function candidates(pids) {
    var inCart = {};
    pids.forEach(function (id) { inCart[id] = true; });
    var lists = pids.map(function (pid) { return (recs[pid] && recs[pid].comp) || []; });
    var longest = Math.max.apply(null, lists.map(function (l) { return l.length; }).concat(0));
    var seen = {};
    var out = [];
    for (var i = 0; i < longest; i++) {
      lists.forEach(function (l) {
        var p = l[i];
        if (!p || seen[p.id] || !isOfferable(p, inCart)) return;
        seen[p.id] = true;
        out.push(p);
      });
    }
    return out;
  }

  function fallback(box) {
    var node = box.querySelector('[data-tbbc-fallback]');
    if (!node) return [];
    try { return JSON.parse(node.textContent) || []; } catch (e) { return []; }
  }

  /* pick up to `limit`; the cheapest candidate that closes the gap goes first and is tagged */
  function pick(pool, gap, limit) {
    var closer = null;
    if (gap > 0) {
      pool.forEach(function (p) {
        if (p.price >= gap && (!closer || p.price < closer.price)) closer = p;
      });
    }
    var list = closer ? [closer] : [];
    pool.forEach(function (p) { if (list.length < limit && p !== closer) list.push(p); });
    return { list: list, closer: closer };
  }

  /* ---------- view ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* "Öljyannostelija 250 ml – airfryeriin, …" → "Öljyannostelija 250 ml": the drawer row names the thing, the page sells it */
  function shortName(title) {
    return String(title || '').split(' – ')[0].split(' - ')[0].trim();
  }

  function buildRow(p, isCloser) {
    var v = p.variants[0];
    var title = shortName(p.title);
    var url = p.url || (ROOT + 'products/' + p.handle);
    var li = el('li', 'tbbc-row');

    var media = el('a', 'tbbc-row__media');
    media.href = url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    var src = p.featured_image || (p.images && p.images[0]);
    if (src) {
      var img = el('img', 'tbbc-row__img');
      img.src = imgUrl(src, 168);
      img.alt = '';
      img.width = 56;
      img.height = 56;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }
    li.appendChild(media);

    var body = el('div', 'tbbc-row__body');
    var name = el('a', 'tbbc-row__name', title);
    name.href = url;
    body.appendChild(name);
    var meta = el('span', 'tbbc-row__meta');
    meta.appendChild(el('span', 'tbbc-row__price', money(v.price)));
    if (isCloser) meta.appendChild(el('span', 'tbbc-row__tag', '→ toimitus 0 €'));
    body.appendChild(meta);
    li.appendChild(body);

    var btn = el('button', 'tbbc-add');
    btn.type = 'button';
    btn.setAttribute('data-tbbc-add', String(v.id));
    btn.setAttribute('aria-label', 'Lisää ostoskoriin: ' + title + ', ' + money(v.price) + (isCloser ? ', toimitus 0 €' : ''));
    var label = el('span', 'tbbc-add__label', 'Lisää');
    label.setAttribute('aria-hidden', 'true');
    var spin = el('span', 'tbbc-spin');
    spin.setAttribute('aria-hidden', 'true');
    btn.appendChild(label);
    btn.appendChild(spin);
    li.appendChild(btn);
    return li;
  }

  function paint(box, pids) {
    var list = box.querySelector('[data-tbbc-list]');
    if (!list) return;
    var subtotal = Number(box.getAttribute('data-subtotal')) || 0;
    var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var threshold = (Number(box.getAttribute('data-threshold')) || 0) * rate;
    var limit = Number(box.getAttribute('data-limit')) || 2;
    var gap = threshold > 0 ? threshold - subtotal : 0;
    var pool = candidates(pids);
    /* carts whose products have no complementary products (the two-pan set) fall back to the section's own short list */
    if (pool.length < limit) {
      var inCart = {};
      pids.forEach(function (id) { inCart[id] = true; });
      fallback(box).forEach(function (p) {
        if (isOfferable(p, inCart) && !pool.some(function (q) { return String(q.id) === String(p.id); })) pool.push(p);
      });
    }
    /* accessories only: nothing above the cap unless it is the row that closes the free-shipping gap */
    var cap = Number(box.getAttribute('data-max-price')) || 4000;
    var closerPrice = Infinity;
    if (gap > 0) pool.forEach(function (p) { if (p.price >= gap && p.price < closerPrice) closerPrice = p.price; });
    var cheap = pool.filter(function (p) { return p.price <= cap || p.price === closerPrice; });
    if (cheap.length) pool = cheap;
    var picked = pick(pool, gap, limit);

    var frag = document.createDocumentFragment();
    picked.list.forEach(function (p) { frag.appendChild(buildRow(p, p === picked.closer)); });
    list.replaceChildren(frag);
    box.hidden = picked.list.length === 0;
  }

  /* render into the current container; data-tbbc-state guards the observer against our own mutations */
  function render() {
    var d = drawer();
    if (!d) return;
    var box = d.querySelector('[data-tbbc-upsell]');
    if (!box || box.getAttribute('data-tbbc-state')) return;
    box.setAttribute('data-tbbc-state', 'pending');
    var pids = cartProductIds(d);
    if (!pids.length) return;

    var missing = pids.filter(function (id) { return !recs[id]; });
    if (pids.length > missing.length) paint(box, pids); // known products paint at once, no flicker
    if (!missing.length) { box.setAttribute('data-tbbc-state', 'done'); return; }
    Promise.all(missing.map(loadRecs)).then(function () {
      if (box.isConnected) {
        paint(box, pids);
        box.setAttribute('data-tbbc-state', 'done');
      }
    });
  }

  function markNewLine() {
    if (!lastAddedVariant) return;
    var d = drawer();
    var li = d && d.querySelector('.cdr__item[data-variant-id="' + lastAddedVariant + '"]');
    lastAddedVariant = null;
    if (!li || reduceMotion) return;
    li.classList.add('tbbc-new');
    window.setTimeout(function () { li.classList.remove('tbbc-new'); }, 1600);
  }

  /* ---------- quick add ---------- */
  function setBusy(btn, busy) {
    btn.disabled = busy;
    if (busy) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  }

  function rowName(btn) {
    var row = btn.closest('.tbbc-row');
    var n = row && row.querySelector('.tbbc-row__name');
    return n ? n.textContent.trim() : '';
  }

  function clearError(row) {
    if (!row) return;
    row.classList.remove('is-error');
    var msg = row.querySelector('.tbbc-row__err');
    if (msg) msg.remove();
  }

  function showError(row) {
    if (!row) return;
    row.classList.add('is-error');
    var body = row.querySelector('.tbbc-row__body');
    if (body && !body.querySelector('.tbbc-row__err')) body.appendChild(el('span', 'tbbc-row__err', 'Ei onnistunut – yritä uudelleen'));
  }

  function quickAdd(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = Number(btn.getAttribute('data-tbbc-add'));
    if (!id) return;
    var row = btn.closest('.tbbc-row');
    clearError(row);
    setBusy(btn, true);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) throw new Error((data && (data.description || data.message)) || ('HTTP ' + r.status));
          return data;
        });
      })
      .then(function () {
        lastAddedVariant = id;
        announce('Lisätty ostoskoriin: ' + rowName(btn));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        // the refresh replaces this button; if it never comes, don't leave a dead spinner behind
        window.setTimeout(function () { if (btn.isConnected) setBusy(btn, false); }, SAFETY_MS);
      })
      .catch(function (err) {
        console.error('[tb-b-cart] quick add failed', err);
        setBusy(btn, false);
        showError(row);
        announce('Tuotetta ei voitu lisätä. Yritä uudelleen.');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tbbc-add]');
    if (!btn || !btn.closest('#CartDrawer')) return;
    e.preventDefault();
    quickAdd(btn);
  });

  document.addEventListener('cart:updated', function () {
    render();
    markNewLine();
  });

  function init() {
    var d = drawer();
    if (!d) return;
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () { queued = false; render(); });
      }).observe(d, { childList: true, subtree: true });
    }
    // warm the cache while the drawer is closed, so it opens with its rows
    var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 1200); };
    idle(render);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
